import { fetch } from '@/shared/fetch';

import { IConsultationDetailsDto } from '@/caregiverSpace/shared/model';

export const fetchConsultationDetails = (
    consultationUID: string,
): Promise<IConsultationDetailsDto> => {
    return fetch(
        `/api/caregiverspace/consultations/${consultationUID}/details`,
        'GET',
    );
};
